import styled, { css } from 'styled-components/macro';
import {
  FlexNoAlign, FlexAlignRight, FlexJustifyCenter,
} from '../../../../../../shared-styles/flex';

export const FormHeader = styled.h2`
  color: ${(props) => props.theme.palette.custom.formHeader};
  font-weight: 300;
`;

export const TopRowContainer = styled.div`
  ${FlexNoAlign};
  margin: ${(props) => props.theme.spacing(20)} 0;
`;

export const StatusInputContainer = styled.div`
  flex-basis: 50%;
  padding-right: ${(props) => props.theme.spacing(20)};
`;

export const DriverLocationInputContainer = styled.div`
  padding-top: ${(props) => props.theme.spacing(10)};
`;

export const LateReasonInputContainer = styled.div`
  padding-top: ${(props) => props.theme.spacing(20)};
`;

export const SubmitButtonContainer = styled.div`
  ${FlexAlignRight};
  ${(props) => props.justifyContent
    && css`
      justify-content: ${props.justifyContent};
    `}
  margin-top: ${(props) => props.theme.spacing(12)};
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter};
`;

export const AdditionalFieldsContainer = styled.div`
  display: grid;
  padding-bottom:${(props) => props.theme.spacing(20)};
  width: 100%;
  grid-template-columns: 2fr 1fr 1fr;
  column-gap: ${(props) => props.theme.spacing(20)};
`;

export const InputDateContainer = styled.div`
  padding-top:${(props) => props.theme.spacing(10)};
`;

export const InputTimeContainer = styled.div`
  padding-top:${(props) => props.theme.spacing(10)};
`;

export const SubText = styled.div`
  ${FlexNoAlign};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  color: ${({ theme }) => theme.palette.black[100]};
  padding-bottom:${(props) => props.theme.spacing(5)};
`;

export const EquipmentLabel = styled.div`
  ${FlexNoAlign};
`;
export const EquipmentLabelValue = styled.div`
  line-height: 1.2;
  font-size: ${(props) => props.theme.typography.sizes.paragraph};
  padding-left: ${(props) => props.theme.spacing(5)};
`;

export const EquipmentContainer = styled.div`
  ${FlexNoAlign};
  margin: ${(props) => props.theme.spacing(10)} 0;
  & ${EquipmentLabel}:not(:first-child) {
    margin-left: ${(props) => props.theme.spacing(30)};
  }
`;

export const AcknowledgementContainer = styled.div`
  ${FlexNoAlign};
`;
